export default class DtoJournal {
    constructor(obj) {
        this.date = obj.date
        this.comment = obj.comment
        this.user = obj.user
        this.function = obj.string
        this.code = obj.code
    }
}